import * as ActionTypes from '../constants/actionTypes'
import {apiClient} from '../lib'
import store from '../store'

import * as openTimeActions from './openTimes'
import * as genderActions from './genders'
import * as breedActions from './breeds'
import * as classificationActions from './classifications'
import * as appointmentTypeActions from './appointmentTypes'
import * as accountActions from './accounts'
import * as administratorActions from './administrators'
import * as restrictionActions from './restrictions'
import * as integrationConfigActions from './integrationConfigs'
import * as appointmentActions from './appointments'
import moment from 'moment'
import { organizationActions } from 'actions'

export const createOrganization = async (values = {}) => {
  store.dispatch({ type: ActionTypes.CREATE_ORGANIZATION })
  
  try{
    const response = await apiClient.organizations.create(values)

    let organizations = []
    try{
      organizations = JSON.parse(localStorage.getItem('organizations')) || []
    }catch(e){
      console.log("Organizations Not Set Properly")
    }

    if(response.data){
      organizations.push(response.data)
      localStorage.setItem('organizations', JSON.stringify(organizations))
    }
    store.dispatch({ type: ActionTypes.CREATE_ORGANIZATION, value: response.data })
  }catch(error){
    store.dispatch({ type: ActionTypes.CREATE_ORGANIZATION_ERROR, patientError: 'This is a patient create error.' })
  }
}

export const superCreateOrganization = async (values = {}) => {
  console.log("NOT SUPPORTED")
 // const response = await apiClient.organizations.create(values)

  return response.data
}

export const update = async (params = {}) => {
  const response = await apiClient.organizations.update(params)

  store.dispatch({
    type: ActionTypes.UPDATE_ORGANIZATION,
    payload: response.data
  })

  store.dispatch({
    type: ActionTypes.SET_ORGANIZATION_CURRENT,
    payload: response.data.id
  })

  return response.data
}

export const changeCurrent = (organizationID)=>{
  store.dispatch({ 
    type: ActionTypes.SET_ORGANIZATION_CURRENT,
    payload: organizationID
  })
  
  openTimeActions.fetch({skipRepeating: true})
  genderActions.fetch();
  breedActions.fetch();
  classificationActions.fetch();
  appointmentTypeActions.fetch();
  accountActions.fetch()
  administratorActions.fetch()
  restrictionActions.fetch()
  integrationConfigActions.fetch()
  appointmentActions.fetch({startingAt: moment().startOf('week').format(), unit: 'week'})
  fetchTypes()
}

export const fetchTypes = async ()=>{
  const response = await apiClient.organizations.fetchTypes()
  store.dispatch({ 
    type: ActionTypes.FETCH_ORGANIZATION_TYPES,
    payload: response.data
  })
}

export const fetch = async ()=>{
  const response = await apiClient.organizations.fetch({integrationConfigs: true})
  if(accountActions.isSuperAdministrator()){
    store.dispatch({ 
      type: ActionTypes.SET_ALL_ORGANIZATIONS,
      payload: response.data
    })
  }else{
    const organizations = []
    const currentOrganizations = store.getState().organizations
    for(let organization of response.data){
      if(currentOrganizations[organization.id]){
        organizations.push(organization)
      }
    }
    store.dispatch({ 
      type: ActionTypes.SET_ALL_ORGANIZATIONS,
      payload: organizations
    })
  }
}


// WEBPACK FOOTER //
// ./src/actions/organizations.js